import { HTTP } from '@/http-common'

function getTransaction (transactionId) {
  return HTTP.get('/transactions/' + transactionId)
}

function addTransaction (transactionData) {
  let data = JSON.stringify(transactionData)

  return HTTP.post('/transactions', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateTransaction (transactionData) {
  let data = JSON.stringify(transactionData)

  return HTTP.put('/transactions/' + transactionData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteTransaction (transactionId) {
  return HTTP.delete('/transactions/' + transactionId)
}

export { getTransaction, addTransaction, updateTransaction, deleteTransaction }



// WEBPACK FOOTER //
// ./src/services/transaction.service.js